import React from 'react'

/**
 * SectionDivider — a labelled horizontal rule separating canvas sections.
 *
 * Props:
 *   label   string  — section label text
 *   action  node    — optional right-side action button/element
 *   notice  string  — optional sub-label notice text (e.g. "unlocks when ready")
 */
export function SectionDivider({ label, action, notice }) {
  const hasAction = !!action

  return (
    <div className={`section-divider${hasAction ? ' section-divider--with-action' : ''}`}>
      <div className="section-divider__label-row">
        <span className="section-divider__label">{label}</span>
        {notice && (
          <span className="section-divider__notice" aria-live="polite">{notice}</span>
        )}
      </div>
      {hasAction && (
        <div className="section-action">{action}</div>
      )}
    </div>
  )
}
